/*
	Licensed Materials - Property of IBM
	IBM Business Analytics (C) Copyright IBM Corp. 2022
	US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

/**
 * @interface CustomColorProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a CustomColor provider for getting a list of used custom colours.
 */
define([], () => {

	class CustomColorProviderAPI {

		/**
		 * @description Returns a list of used custom colors
		 * @returns {string[]} An array of strings that are hex colors in the format "#RRGGBB"
		 */
		getCustomColorList() {}

	}

	return CustomColorProviderAPI;
});
